module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0071.jpg?v=a610ed94";